export default {
	title: "Web3",
	rule: "Описание правил",
	safe: "Безопасность средств",
	balance: {
		total: "Общий сумма",
		yesterday: "Доход вчера",
		cumulatively: "Накопленный доход",
		in: "Сумма пополнения",
		out: "Сумма снятия",
		available: "Доступный баланс"
	},
	actions: {
		in: "Пополнение",
		out: "Снятие"
	},
	type: ["Все", "Пополнение", "Снятие", "Доход"],
	TransactionPassword: "Пароль транзакции",
	Amount: "Сумма",
	date: "Дата"
};
